import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import Loader from "../Common/Loader";
import AuthContext from "../../Context/AuthContext";
import toast from "react-hot-toast";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
// Modals
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxProject from "../../util/remote/ajaxProject";
import InventoryJournalUpdate from "./InventoryJournalUpdate";
import InventoryJournalPrintable from "./InventoryJournalPrintable";
import TransactionCatUpdater from "./TransactionCatUpdater";
import InventoryJournalPrintableWzStatement from "./InventoryJournalPrintableWzStatement";
function PaidJournalsInventory(props) {
  const cost_allocations = props.cost_allocations;
  const employees = props.employees;
  const trans_type = "journal_inve";
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [unpaidJournals, setUnpaidJournals] = useState([]);
  const [projects, setProjects] = useState([]);
  const [projectID, setProjectID] = useState("");
  const [start_date, setStart_date] = useState("");
  const [state, setState] = useState("paid");
  const [to_date, setTo_date] = useState("");
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState([]);
  // Modals state
  const [UpdateVoucher, setUpdateVoucher] = useStateCallback(false);
  const [AddOnvoucher, setAddOnvoucher] = useStateCallback(false);
  const [voucherCat, setVoucherCat] = useStateCallback(false);
  const [printing, setPrinting] = useStateCallback(false);
  // Fetch projects for filter
  const getProjects = async () => {
    const server_response = await ajaxProject.getProjectsMinnimalDataCliented();
    if (server_response.status === "OK") {
      const allOption = { id: "", project_name: "All Projects" };
      setProjects([allOption, ...server_response.details]);
    } else {
      setProjects("404");
    }
  };
  // Fetch unpaid journals with pagination & filters
  const fetchUnpaidJournals = async () => {
    setLoading(true);
    try {
      const data = {
        projectID: projectID,
        trans_type: "journal_inve",
        page: page,
        start_date: start_date,
        to_date: to_date,
        state: state,
      };
      const response = await ajaxAccounting.getUnpaidJournals(data);
      if (response.status === "OK") {
        setUnpaidJournals(response.details);
      } else {
        setUnpaidJournals([]);
        toast.error("No unpaid journals found");
      }
    } catch (err) {
      toast.error("Error fetching unpaid journals");
      setUnpaidJournals([]);
    }
    setLoading(false);
  };
  useEffect(() => {
    getProjects();
    const today = new Date().toISOString().split("T")[0];
    setTo_date(today);
  }, []);
  useEffect(() => {
    fetchUnpaidJournals();
  }, [projectID, page, start_date, to_date]);

  // --- Modal Handlers ---
  const handleVoucherUpdate = (e, id) => {
    e.preventDefault();
    setUpdateVoucher(false, () =>
      setUpdateVoucher(
        <InventoryJournalUpdate
          isOpen={true}
          id={id}
          employees={employees}
          function={props.function()}
        />
      )
    );
  };
  const handlePrinting = (e, id) => {
    e.preventDefault();
    setPrinting(false, () =>
      setPrinting(
        <InventoryJournalPrintable isOpen={true} id={id} type={trans_type} />
      )
    );
  };
  const handvoucherCAtItem = (e, reference, item) => {
    e.preventDefault();
    setVoucherCat(false, () =>
      setVoucherCat(
        <TransactionCatUpdater
          isOpen={true}
          function={props.function()}
          cost_allocations={cost_allocations}
          reference={reference}
          item={item}
        />
      )
    );
  };
  const DeleteTransaction = async (e, InvoiceID) => {
    e.preventDefault();
    const isConfirmed = window.confirm(
      "Are you sure you want to Delete this item ?"
    );

    if (isConfirmed) {
      var dataa = {
        reff: InvoiceID,
      };
      const server_response =
        await ajaxAccounting.DeleteinventoryJournalTransaction(dataa);

      if (server_response.status === "OK") {
        toast.success(server_response.message);
        props.function();
      } else {
        toast.error(server_response.message);
      }
    }
  };
  const [statement, setStatement] = useStateCallback(false);

  const handlestatement = (e, id, reff) => {
    e.preventDefault();
    setStatement(false, () =>
      setStatement(
        <InventoryJournalPrintableWzStatement
          isOpen={true}
          id={id}
          type={trans_type}
          reff={reff}
        />
      )
    );
  };
  return (
    <div className="row">
      {/* Modals */}
      {UpdateVoucher}
      {AddOnvoucher}
      {voucherCat}
      {printing}
      {statement}
      {/* Filters */}
      <div className="col-lg-3 col-md-6 mb-3">
        <Select
          onChange={(e) => setProjectID(e.id)}
          getOptionLabel={(option) => option.project_name}
          getOptionValue={(option) => option.id}
          options={Array.isArray(projects) && projects}
          value={
            (Array.isArray(projects) &&
              projects.find((p) => p.id === projectID)) ||
            projects[0]
          }
          placeholder="Filter by Project"
        />
      </div>
      <div className="col-lg-3 col-md-6 mb-3">
        <input
          type="date"
          value={start_date}
          onChange={(e) => setStart_date(e.target.value)}
          className="form-control"
          placeholder="From"
        />
      </div>
      <div className="col-lg-3 col-md-6 mb-3">
        <input
          type="date"
          value={to_date}
          onChange={(e) => setTo_date(e.target.value)}
          className="form-control"
          placeholder="To"
        />
      </div>
      <div className="col-lg-3 col-md-6 mb-3">
        <button
          className="btn btn-primary col-12"
          onClick={fetchUnpaidJournals}
        >
          <i className="fa-brands fa-searchengin"></i> Get Data
        </button>
      </div>
      {/* Table */}
      <div className="col-lg-12 col-md-12">
        <div className="table-responsive">
          <table
            className="table table-striped table-bordered"
            style={{ border: "orange 3px groove" }}
          >
            {loading && <Loader />}
            <thead>
              <th>#</th>
              <th>Journal_reff</th>
              <th>Supplier_ref</th>
              <th>Project</th>
              <th>ledger Debited</th>
              <th>ledger Credited</th>
              <th>Amount</th>
              <th>details</th>
              <th>
                cost Allocation <br />
                Item
              </th>
              <th>Date</th>
              <th>Reciever</th>
              <th>Created By</th>
              <th>Action</th>
            </thead>
            <tbody>
              {Array.isArray(unpaidJournals) &&
                unpaidJournals.map((item, key) => (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <th>{item.folio_reff}</th>
                    <th>{item.supplier_reff}</th>
                    <td>{item.projectID.project_name}</td>
                    <td>
                      {item.ledgerID_debited.Ledger_name}
                      <br />
                      <span>
                        <button
                          onClick={(e) => handleVoucherUpdate(e, item.id)}
                          style={{
                            borderRadius: "5px",
                            margin: "2px",
                          }}
                          className="btn ripple btn-warning btn-sm"
                        >
                          <i class="fa-solid fa-pen-to-square"></i>
                          &nbsp; Update
                        </button>
                        <br />
                        <button
                          onClick={(e) =>
                            handlestatement(e, item.id, item.supplier_reff)
                          }
                          style={{
                            borderRadius: "5px",
                            margin: "2px",
                          }}
                          className="btn ripple btn-primary btn-sm"
                        >
                          <i class="fa-regular fa-eye"></i>
                          &nbsp; statement
                        </button>
                        <button
                          onClick={(e) => handlePrinting(e, item.id)}
                          style={{
                            borderRadius: "5px",
                            margin: "2px",
                          }}
                          className="btn ripple btn-secondary btn-sm"
                        >
                          <i class="fa-solid fa-print"></i>
                          &nbsp; print
                        </button>
                      </span>
                    </td>
                    <td>{item.ledgerID_credited.Ledger_name}</td>
                    <td>{item.amount.amount_p}</td>
                    <td
                      style={{
                        width: "200px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {item.description}
                    </td>
                    <td>
                      {item.catID ? (
                        item.catID.item
                      ) : (
                        <>
                          <button
                            onClick={(e) =>
                              handvoucherCAtItem(e, item.reference, item)
                            }
                            style={{ borderRadius: "5px" }}
                            className="btn ripple btn-primary btn-sm"
                          >
                            <i class="fa-solid fa-plus"></i>
                            Add CAC
                          </button>
                        </>
                      )}{" "}
                    </td>
                    <td>{item.date.short_date}</td> <td>{item.reciever}</td>
                    <td>{item.created_by.name}</td>
                    <td>
                      <button
                        style={{
                          borderRadius: "10px",
                          fontSize: "14px",
                          height: "10px",
                          margin: "2px",
                          color: "white",
                          background:
                            "linear-gradient(to right,rgb(245, 24, 24),rgb(186, 102, 12))",
                        }}
                        onClick={(e) => DeleteTransaction(e, item.id)}
                        className="btn ripple btn-outline-success btn-with-icon"
                        to="#"
                      >
                        <i class="fa-solid fa-trash-can-arrow-up"></i>
                        &nbsp;
                        <span className="sidemenu-label">{/* delete */}</span>
                      </button>{" "}
                    </td>
                  </tr>
                ))}
              {loading && <Loader />}
              {unpaidJournals === "404" && (
                <>
                  <tr>
                    <td colSpan={10}>
                      <p className="text-center text-info">
                        No data found in the system
                      </p>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
export default PaidJournalsInventory;
